/**
 * @generated SignedSource<<f4b9388bf1f1ed758a019fbb0271faaf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ClubQueueItPreflightQuery$variables = {
  clubSlug: string;
};
export type ClubQueueItPreflightQuery$data = {
  readonly unauthenticatedClub: {
    readonly queueIt: {
      readonly customerId: string;
      readonly nativeWaitingRoomAlias: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ClubQueueItPreflightQuery = {
  response: ClubQueueItPreflightQuery$data;
  variables: ClubQueueItPreflightQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clubSlug"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "clubSlug"
      }
    ],
    "concreteType": "UnauthenticatedClub",
    "kind": "LinkedField",
    "name": "unauthenticatedClub",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QueueItConfiguration",
        "kind": "LinkedField",
        "name": "queueIt",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nativeWaitingRoomAlias",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClubQueueItPreflightQuery",
    "selections": (v1/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClubQueueItPreflightQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "40f4b043753849b234440936f419b400",
    "id": null,
    "metadata": {},
    "name": "ClubQueueItPreflightQuery",
    "operationKind": "query",
    "text": "query ClubQueueItPreflightQuery(\n  $clubSlug: String!\n) {\n  unauthenticatedClub(slug: $clubSlug) {\n    queueIt {\n      customerId\n      nativeWaitingRoomAlias\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7886b7e667bbd08c15d977c620df010c";

export default node;
